module.exports = __webpack_public_path__ + "static/media/Flip-Coin-5.8232f944.png";